import { OrderType, OrderStatus } from '@/types';

export interface OrdersFilterOptions {
    units: number[];
    itemCategories: number[];
    statuses: OrderStatus[];
    owners: number[];
    orderTypes: OrderType[];
    searchText: string;
    tags: number[];
    residentialUnitGroupIds: number[];
    projectDeadlineIds: number[];
    defaultBuyerOptions: 'All' | 'HideDefault';
    orderDateFrom: Date | string | null;
    orderDateTo: Date | string | null;
}

export class OrdersFilterOptions {
    static empty(): OrdersFilterOptions {
        return {
            units: [],
            itemCategories: [],
            statuses: [],
            owners: [],
            orderTypes: [],
            searchText: '',
            tags: [],
            residentialUnitGroupIds: [],
            projectDeadlineIds: [],
            defaultBuyerOptions: 'All',
            orderDateFrom: null,
            orderDateTo: null
        };
    }
}

export { default } from './OrderFilters';